import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = [ 'wrapper', 'content' ];

  notify ({ text, type }) {
    const container_class = 'flex gap-x-3 pl-4 py-4 pr-10 relative text-sm rounded-md'

    const classByType = {
      error: 'bg-red-50 text-red-800',
      success: 'bg-green-50 text-green-800',
      primary: 'bg-blue-50 text-blue-800',
      warning: 'bg-yellow-50 text-yellow-800'
    };

    // Remove all possible classes first
    Object.values(classByType).forEach(classes => {
      classes.split(' ').forEach(className => {
        this.wrapperTarget.classList.remove(className);
      });
    });
    
    // Add the new classes for the current type
    classByType[type].split(' ').forEach(className => {
      this.wrapperTarget.classList.add(className);
    });

    container_class.split(' ').forEach(className => {
      this.wrapperTarget.classList.add(className);
    });

    this.contentTarget.innerHTML = text;
    this.element.style.display = 'block';
    this.scrollUpSmoothly();
  }

  scrollUpSmoothly () {
    window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
  }
}
